export const PAGE_ID_0 = 'PAGE_0_LOADING';
export const PAGE_ID_1 = 'PAGE_1_ALL_BRANDS';
export const PAGE_ID_2 = 'PAGE_2_BRAND_SELECTION';
export const PAGE_ID_3 = 'PAGE_3_MODEL_SELECTION';
